import {
  GET_APP_CONFIGS,
  GET_APP_CONFIGS_ERROR,
  GET_APP_CONFIGS_SUCCESS,
  GetAppConfigsAction,
  GetAppConfigsErrorAction,
  GetAppConfigsSuccessAction,
  UPDATE_APP_CONFIGS,
  UPDATE_APP_CONFIGS_ERROR,
  UPDATE_APP_CONFIGS_SUCCESS,
  UpdateAppConfigsAction,
  UpdateAppConfigsErrorAction,
  UpdateAppConfigsSuccessAction,
} from "./actionTypes";
import { AppConfigDto, UpdateAppConfigsRequest } from "../../interfaces";

//#region Get AppConfigs

export const getAppConfigs = (): GetAppConfigsAction => {
  return {
    type: GET_APP_CONFIGS,
    payload: {},
  };
};

export const getAppConfigsSuccess = (
  response: AppConfigDto[]
): GetAppConfigsSuccessAction => {
  return {
    type: GET_APP_CONFIGS_SUCCESS,
    payload: response,
  };
};

export const getAppConfigsError = (error: any): GetAppConfigsErrorAction => {
  return {
    type: GET_APP_CONFIGS_ERROR,
    payload: error,
  };
};
//#endregion

//#region Update AppConfigs

export const updateAppConfigs = (
  request: UpdateAppConfigsRequest
): UpdateAppConfigsAction => {
  return {
    type: UPDATE_APP_CONFIGS,
    payload: { request },
  };
};

export const updateAppConfigsSuccess = (
  response: AppConfigDto[]
): UpdateAppConfigsSuccessAction => {
  return {
    type: UPDATE_APP_CONFIGS_SUCCESS,
    payload: response,
  };
};

export const updateAppConfigsError = (
  error: any
): UpdateAppConfigsErrorAction => {
  return {
    type: UPDATE_APP_CONFIGS_ERROR,
    payload: error,
  };
};
//#endregion
